import { render, staticRenderFns } from "./CatalogItemEdit.vue?vue&type=template&id=7f592b10&"
import script from "./CatalogItemEdit.vue?vue&type=script&lang=js&"
export * from "./CatalogItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports